import { Canton } from "./../../_model/canton/canton";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { config } from "environments/config";

@Injectable({
    providedIn: "root",
})
export class CantonService {
    constructor(private http: HttpClient) {}

    getListCanton() {
        return this.http
            .get<any>(`${config.apiUrl}/canton/listar`)
            .toPromise()
            .then((res) => <Canton[]>res.data)
            .then((data) => {
                return data;
            });
    }
}
